import { Button } from "@/components/ui/button";
import { Calendar } from "@/components/ui/calendar";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuSeparator,
  DropdownMenuTrigger
} from "@/components/ui/dropdown";
import { format } from "date-fns";
import { Calendar as CalendarIcon } from "lucide-react";

interface Props {
  selectedDate: Date | undefined;
  updateDate: (newDate: Date | undefined) => void;
  excludeBefore?: Date | undefined;
  excludeAfter: Date | undefined;
  buttonText: string;
}

export function CalendarRangeFilter({
  selectedDate,
  updateDate,
  excludeBefore,
  excludeAfter,
  buttonText
}: Props) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size="default" className="h-8">
          <CalendarIcon className="mr-2 h-4 w-4" />
          {buttonText}:{" "}
          {selectedDate ? format(selectedDate, "MMM d, y") : "----"}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align="end"
        className="w-[20rem] flex flex-col items-center"
      >
        <Calendar
          className="w-full bg-transparent"
          mode="single"
          captionLayout="dropdown"
          disabled={(date) =>
            (excludeAfter && date > excludeAfter) ||
            (excludeBefore && date < excludeBefore) ||
            false
          }
          selected={selectedDate}
          onSelect={updateDate}
        />
        <DropdownMenuSeparator className="w-full" />
        <Button
          variant="ghost"
          disabled={!selectedDate}
          onClick={() => updateDate(undefined)}
        >
          Clear selection
        </Button>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
